export default __webpack_public_path__ + "static/char-s-15-kr-4d60203965fea6c5fbc97d99c07773a4.png";